import api from '../api';
import { GetUsersRequest, GetUsersResponse, UserOutput } from '@ilteducation/customer-mgmt-types';
import { ref } from 'vue';

export const useGetUsers = () => {
  const users = ref<GetUsersResponse | null>(null);
  const error = ref<null | unknown>(null);
  const isLoading = ref<boolean>(false);
  const getUsers = async (request: GetUsersRequest): Promise<GetUsersResponse | null> => {
    try {
      isLoading.value = true;
      const response = await api.users.get(request);
      users.value = response.data;
    } catch (err: unknown) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }

    return users.value;
  };

  const fetchAllUsers = async (payload: GetUsersRequest): Promise<UserOutput[]> => {
    const requestPayload = { pageNumber: 1, pageSize: 100, ...payload };
    const { data } = await api.users.get(requestPayload);
    let users: UserOutput[] = data.data;
    const total = data.meta.totalItems ?? 0;
    const diff = total - data.data.length;
    if (diff > 0) {
      const chunkCount = Math.ceil(diff / 100);
      const requests = Array.from({ length: chunkCount }, (v: unknown, index) =>
        api.users.get({ ...requestPayload, pageNumber: index + 2, pageSize: 100 }),
      );
      const results = await Promise.all(requests);
      users = [...users, ...results.map((r) => r.data.data)].flat();
    }
    return users;
  };

  return {
    getUsers,
    fetchAllUsers,
    isLoading,
    users,
    error,
  };
};
